<bb-currency-input-ui
  [formControl]="amount"
  [currencies]="currencies"
  [allowNegativeValue]="true"
  resultType="string"
></bb-currency-input-ui>
